import type { MbTrackPulse } from "#shared/schemas/mbEnrich.ts";

/** "1 recording · 3 artists · 2 releases · 12 req" */
export function formatTrackPulse(pulse: MbTrackPulse): string {
  const parts = pulse.by_type.map((row) => {
    const base = row.entity_type;
    const label = row.count === 1 ? base : base.endsWith("s") ? base : `${base}s`;
    return `${row.count} ${label}`;
  });
  if (pulse.requests > 0) {
    parts.push(`${pulse.requests} req`);
  }
  return parts.length > 0 ? parts.join(" · ") : "nothing new";
}
